import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ClarityService } from '@services/clarity.service';
import { gebcoBathyBaseMapLayers } from '../../layers/gebco-bathy-base-map.layer';
import { FieldViewControlService } from '../../services/field-view-control.service';

const materialDs = [MatFormFieldModule, MatCheckboxModule, MatSelectModule];

@Component({
  selector: 'app-layers-panel',
  templateUrl: './layers-panel.component.html',
  imports: [...materialDs],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayersPanelComponent {
  private readonly fieldViewControlService = inject(FieldViewControlService);
  private readonly clarityService = inject(ClarityService);

  readonly seaMapVisibilitySignal = this.fieldViewControlService.seaMapVisibility;

  readonly gebcoBathyBaseMapLayers = gebcoBathyBaseMapLayers;

  readonly selectedBathyBaseMapLayerSignal = this.fieldViewControlService.selectedBathyBaseMapLayer;

  constructor() {
    this.clarityService.initializeClarity();
  }

  updateSeaMap(value: boolean): void {
    this.clarityService.clarityEvent(`field-view:sea-map-check-${value}`);
    this.fieldViewControlService.setSeaMapVisibility(value);
  }

  updateSelectedBathyBaseMapLayer(value: string): void {
    this.clarityService.clarityEvent(`field-view:bathy-map-select-${value}`);
    this.fieldViewControlService.setSelectedBathyBaseMapLayer(value);
  }
}
